module.exports = __webpack_public_path__ + "static/img/news-img3.3795367.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news-img3.png
// module id = otN0
// module chunks = 3